let debugModeVisible = false;

export function setDebugModeVisible(visible) {
    debugModeVisible = !!visible;
}

export function isDebugModeVisible() {
    return debugModeVisible;
}
